import { useEffect, useState } from 'react';
import Iconify from 'src/components/iconify';
import SerpModal from './SerpModal';
import { SerpModalProps } from '../types';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';

interface SerpModalButtonProps {
    gcsUrl?: string | null;
    deviceType?: string | null;
    iconType: 'mobile' | 'desktop';
    searchTerm?: string;
}

function SerpModalButton({ gcsUrl, deviceType, iconType, searchTerm }: SerpModalButtonProps) {
    const [serpModalOpen, setSerpModalOpen] = useState(false);
    const [serpPayload, setSerpPayload] = useState<SerpModalProps['payload']>({
        startDate: '2025-08-02',
        endDate: '2025-08-31',
        keywords: ['polene'],
        countries: 'Australia',
        devices: deviceType || 'DESKTOP',
        workspaceId: 48,
        offset: 0,
        pageSize: 5,
        platform: 'Google',
        gcsUrl: gcsUrl || '',
        searchTerm: searchTerm || '',
        deviceType: iconType
    });

    // Update payload when search term or gcsUrl changes
    useEffect(() => {
        setSerpPayload(prev => ({
            ...prev,
            searchTerm: searchTerm || '',
            gcsUrl: gcsUrl || ''
        }));
    }, [searchTerm, gcsUrl]);

    // Validate GCS URL
    const hasValidGcsUrl = gcsUrl &&
        typeof gcsUrl === 'string' &&
        gcsUrl.trim() !== '' &&
        gcsUrl !== 'null' &&
        gcsUrl !== 'undefined' &&
        gcsUrl.startsWith('gs://');

    return (
        <>
            <Box
                onClick={hasValidGcsUrl ? () => setSerpModalOpen(true) : undefined}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.5,
                    cursor: hasValidGcsUrl ? 'pointer' : 'not-allowed',
                    opacity: hasValidGcsUrl ? 1 : 0.3,
                    color: '#0076C9',
                    '&:hover': {
                        opacity: hasValidGcsUrl ? 0.8 : 0.3,
                    },
                }}
            >
                <Typography
                    sx={{
                        color: '#006C9C',
                        fontFamily: '"Public Sans", sans-serif',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: '16px',
                    }}
                >
                    See SERP
                </Typography>

                <Iconify
                    icon={
                        iconType === 'mobile'
                            ? 'solar:smartphone-outline'
                            : 'solar:laptop-outline'
                    }
                    width={16}
                    height={16}
                />
            </Box>

            {hasValidGcsUrl && (
                <SerpModal
                    open={serpModalOpen}
                    onClose={() => setSerpModalOpen(false)}
                    payload={serpPayload}
                    deviceType={iconType}
                />
            )}
        </>
    );
}

export default SerpModalButton;


